import { css } from '@linaria/core';
import { styled } from '@linaria/react';

import { ButtonIconGhost } from '~shared/ui/atoms/Buttons/ButtonGhost/Icon';
import { MqTablet } from '~theme/media';

export const Spacer = styled.div`
	flex-grow: 1;
`;

export const modal = css`
	overflow: auto;
	flex-direction: column;
`;

export const DeleteAccountContent = styled.form`
	position: relative;
	display: flex;
	width: calc(100% - 4rem);
	max-width: 47rem;
	flex-direction: column;
	padding: 2.4rem;
	border-radius: var(--radius-l);
	margin-right: auto;
	margin-left: auto;
	background: var(--color-grey-10-solid);
	gap: var(--gap-x5);

	& > *:first-child {
		margin-left: -0.8rem;
	}

	${MqTablet} {
		padding: 3.2rem 3.2rem 2.4rem;
	}
`;

export const CloseButton = styled(ButtonIconGhost)`
	position: absolute;
	top: calc(1rem + var(--safe-top));
	right: 1rem;
`;

export const Actions = styled.div`
	display: flex;
	width: 100%;
	justify-content: center;
	padding-top: 0.8rem;
	gap: var(--gap-x4);

	& > *:first-child {
		color: var(--color-red-50-solid);
	}

	& * {
		flex-basis: 0;
		flex-grow: 1;
		justify-content: center;
	}
`;
